export const verifyPasswordChar = (passwordVal) => {
  if (passwordVal.length >= 8) {
    return true
  }else {
    return false
  }
}
export const verifyPasswordLowcase = (passwordVal) => {
  return (/[a-z]/.test(passwordVal))
}
export const verifyPasswordUppercase = (passwordVal) => {
  return (/[A-Z]/.test(passwordVal))
}
export const verifyPasswordNumber = (passwordVal) => {
  return (/[0-9]/.test(passwordVal))
}
export const isEmpty = (value) => {
  if (value && value.length > 0) {
    return false
  }
  return true
};


export const validEmail = (email) => {
  return (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email))
}



// WEBPACK FOOTER //
// ./src/utils/helpers/validationPassword.js